import { delivery, VALIDITY, validityText, fmtTs } from "./otpUtils";

const Chip = ({ cls, children, testid }) => <span data-testid={testid} className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs whitespace-nowrap ${cls}`}>{children}</span>;

export function OtpRequestRow({ r, onOpen, showChannel }) {
  const d = delivery(r.status);
  const v = VALIDITY[r.validity?.state] || VALIDITY.expired;
  const ref = r.metadata ? Object.values(r.metadata).slice(0, 2).join(" · ") : "";
  return (
    <li>
      <button type="button" onClick={() => onOpen(r.id)} data-testid={`otp-row-${r.id}`} className="w-full text-left rounded-xl border border-[#1F2937] bg-[#111827]/80 hover:border-[#10B981]/40 transition-colors px-4 py-3">
        <div className="grid gap-2 md:grid-cols-[150px_150px_80px_1fr_1fr_120px] md:items-center">
          <span className="text-xs text-slate-400 font-mono">{fmtTs(r.created_at)}</span>
          <span className="text-sm text-slate-100 font-mono" data-testid={`otp-row-number-${r.id}`}>{r.to_masked}</span>
          <span className="text-xs text-slate-300 uppercase">{showChannel ? (r.channel_initial === "whatsapp" ? "WA" : "SMS") : ""}</span>
          <Chip cls={v.cls}>{v.label} <span className="text-slate-400 normal-case">{validityText(r.validity)}</span></Chip>
          <Chip cls={d.cls} testid={`otp-row-status-${r.id}`}>{d.icon} {d.label}{r.whatsapp?.error_code ? ` · ${r.whatsapp.error_code}` : ""}</Chip>
          <span className="text-xs text-slate-500 truncate" title={r.external_request_id}>{ref || r.external_request_id}</span>
        </div>
      </button>
    </li>
  );
}
